import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';

// ONLY LEGACY ROUTES HERE
const projectWebanalyticsRoutes = [
  {
    path: 'webanalytics',
    component: NestedRouteComponent,
    children: [
      {
        path: 'old',
        name: 'webAnalyticsProfilesOld',
        component: wrapLegacyRoute('webAnalyticsController', 'profileList')
      },
      {
        path: 'create',
        name: 'webAnalyticsProfileCreate',
        component: wrapLegacyRoute('webAnalyticsController', 'profileCreate')
      },
      {
        path: ':profileId(\\d+)/old',
        name: 'webAnalyticsProfileDetailsOld',
        component: wrapLegacyRoute('webAnalyticsController', 'profileDetails')
      }
    ]
  }
];

export default projectWebanalyticsRoutes;
